export class DomainRecord {
    ID: number;
    Code: string;
    Name: string;
    Inactive: boolean;
    SubtradeCategoryName: string;
    IEI_Eligible: boolean;
    EnhancedPaymentOptions: boolean;
    MinimumOrderQuantityFeeCode: boolean;
    AppliesToSoldTo: boolean;
    BusinessTypeExtension: string;
    AuthorizedMaterialList: string;
    DrPepperAuthorizedMaterialList: string;
    MerchLevelCode: string;
    OffDayDeliveryFee: boolean;
    SalesOfficeNumber: string;
    ClerkCode: string;
    ToleranceGroup: string;
    FountainAvailable: boolean;
    DistributionChannel: string;
    RequestReasonIDs: string;
    RequiredAttachmentTypeIDs: string;
    IEI_EligibilityText: string;
    EnhancedPaymentOptionsText: string;
    PaymentEligibilityType: string;
    CRTNumber: string;
    PrimaryGroup: string;
    MyCokePermissions: string;
}

export default DomainRecord;